import React from 'react';

export interface SeparatorProps {}

const Separator: React.FC<SeparatorProps> = ({}) => {
  return <div className="Separator" />;
};

export default Separator;
